export default function SoftSkillsByRole() {
  const roles = [
    {
      role: 'Soft Skills для руководителя',
      icon: 'ri-user-star-line',
      skills: [
        { name: 'Лидерство и влияние', desc: 'Способность вести людей за собой, вдохновлять на достижение целей, принимать непопулярные решения и отвечать за результат всей команды.' },
        { name: 'Стратегическое мышление', desc: 'Умение видеть картину целиком, связывать операционные задачи со стратегией, предвидеть последствия решений на 2-3 шага вперёд.' },
        { name: 'Управление изменениями', desc: 'Проведение команды через трансформации, работа с сопротивлением, создание среды, где изменения воспринимаются как возможность.' },
        { name: 'Развитие сотрудников', desc: 'Умение раскрывать потенциал подчинённых, давать развивающую обратную связь, строить системы наставничества и преемственности.' },
      ]
    },
    {
      role: 'Soft Skills для менеджера по продажам',
      icon: 'ri-line-chart-line',
      skills: [
        { name: 'Эмпатия и активное слушание', desc: 'Понимание истинных потребностей клиента, а не просто отработка скрипта. Умение слышать то, что не сказано словами.' },
        { name: 'Навыки переговоров', desc: 'Подготовка, выявление интересов, работа с возражениями и завершение сделки. Переговоры — это 80% успеха в продажах.' },
        { name: 'Стрессоустойчивость', desc: 'Способность сохранять позитивный настрой после десятков отказов и продолжать работать с той же энергией на следующей встрече.' },
        { name: 'Самоорганизация', desc: 'Управление воронкой продаж, расстановка приоритетов между клиентами и контроль собственного времени без внешнего давления.' },
      ]
    },
    {
      role: 'Soft Skills для HR-специалиста',
      icon: 'ri-group-line',
      skills: [
        { name: 'Эмоциональный интеллект', desc: 'Распознавание эмоционального состояния сотрудников, эмпатия при проведении сложных разговоров и увольнений, управление собственными эмоциями.' },
        { name: 'Коммуникация и фасилитация', desc: 'Проведение встреч и обсуждений, модерация конфликтов, способность доносить непопулярные решения до коллектива.' },
        { name: 'Критическое мышление', desc: 'Анализ причин текучести, оценка эффективности программ обучения, объективная оценка кандидатов без когнитивных искажений.' },
        { name: 'Клиентоориентированность', desc: 'Понимание потребностей внутреннего клиента — сотрудников и руководителей, проактивный подход к решению их проблем.' },
      ]
    },
    {
      role: 'Soft Skills для руководителя проектов',
      icon: 'ri-projector-line',
      skills: [
        { name: 'Управление коммуникацией', desc: 'Выстраивание прозрачных каналов общения между заказчиком, командой и стейкхолдерами. Своевременное информирование о рисках.' },
        { name: 'Решение проблем', desc: 'Способность быстро находить выход из нестандартных ситуаций, принимать решения при неполной информации и брать ответственность за результат.' },
        { name: 'Работа в команде', desc: 'Построение доверия в кросс-функциональной команде, управление конфликтами интересов, мотивация без формальной власти.' },
        { name: 'Гибкость и адаптивность', desc: 'Готовность менять план при изменении требований, сохраняя фокус на цели проекта и управляя ожиданиями заказчика.' },
      ]
    },
    {
      role: 'Soft Skills для сервисного персонала',
      icon: 'ri-customer-service-2-line',
      skills: [
        { name: 'Клиентоориентированность', desc: 'Способность поставить себя на место клиента, проявить эмпатию и найти решение, даже выходящее за рамки стандартных инструкций.' },
        { name: 'Управление конфликтами', desc: 'Работа с недовольными клиентами: снижение эмоционального напряжения, перевод разговора в конструктивное русло и достижение результата.' },
        { name: 'Стрессоустойчивость', desc: 'Сохранение спокойствия и профессионализма при общении с агрессивными клиентами, работа в условиях высокой эмоциональной нагрузки.' },
        { name: 'Коммуникативные навыки', desc: 'Умение объяснять сложное простыми словами, подбирать правильный тон и стиль общения под конкретного клиента и ситуацию.' },
      ]
    },
    {
      role: 'Soft Skills для офисных сотрудников',
      icon: 'ri-computer-line',
      skills: [
        { name: 'Тайм-менеджмент', desc: 'Расстановка приоритетов в потоке задач, умение сказать «нет» неважному и сохранить фокус на главном без жёсткого контроля со стороны.' },
        { name: 'Командное взаимодействие', desc: 'Эффективное участие в совещаниях, конструктивная обратная связь коллегам, готовность помочь и принять помощь без создания напряжения.' },
        { name: 'Инициативность', desc: 'Проактивный подход: предлагать улучшения, а не ждать указаний; видеть проблему и предлагать решение, а не сообщать о проблеме.' },
        { name: 'Цифровой этикет', desc: 'Культура деловой переписки, правила работы в мессенджерах и видеоконференциях, соблюдение баланса между доступностью и личными границами.' },
      ]
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Soft Skills для разных сотрудников
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Каждая роль в компании требует своего набора Soft Skills. Программа обучения адаптируется под должность, уровень и задачи конкретного сотрудника
        </p>

        <div className="space-y-8">
          {roles.map((role, i) => (
            <div key={i} className="bg-gray-50 rounded-2xl p-6 md:p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${role.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900">{role.role}</h3>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {role.skills.map((skill, j) => (
                  <div key={j} className="bg-white p-5 rounded-xl">
                    <h4 className="font-bold text-gray-900 mb-2 text-sm">{skill.name}</h4>
                    <p className="text-gray-600 text-xs leading-relaxed">{skill.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}